<agr-page-detail
  [pageTitle]="getTitle()"
  [hasPrimaryAction]="false"
  data-test="feed-advice-from-reference__overview"
  (backAction)="back()"
>
  <div class="wrapper--spacing-horizontal">
    <div class="spacing--margin-top">
      <div class="filtering__container">
        <h3>{{ 'from-reference.filtering-title' | translate }}</h3>
        <a class="clear-filtering" (click)="clearFilteringProperties()">
          <mat-icon>arrow_forward</mat-icon>
          {{ 'from-reference.clear-filtering' | translate }}
        </a>
        <!-- Filter options for Fattening / Rearing Reference Feedadvices-->
        <app-feed-advice-properties
          *ngIf="isFatteningOrRearingOrPigletsFeedadvice()"
          [feedAdviceType]="feedAdviceType"
          [genders]="genders"
          [feedintake]="feedintake"
          [phaseTransition]="phaseTransition"
          [phases]="phases"
          [geneticLine]="geneticLine"
          [hasValidation]="false"
          (propertiesChanged)="changeFilteringProperties($event)"
        ></app-feed-advice-properties>

        <!-- Filter options for Sows Reference Feedadvices-->
        <app-sows-feed-advice-properties
          *ngIf="isSowsFeedadvice()"
          [feedAdviceType]="feedAdviceType"
          [bodyCondition]="bodyCondition"
          [geneticLine]="geneticLine"
          (propertiesChanged)="changeFilteringProperties($event)"
        >
        </app-sows-feed-advice-properties>

        <div class="spacing--margin-top">
          <span class="text--small text--bold label"> {{ 'region' | translate }}: </span>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            class="flex__child--auto spacing--margin-right text--small regionSelector"
            data-placeholder="{{ 'region' | translate }}"
            data-test="country-selector"
            (selectionChange)="changeRegionSelection($event)"
            [value]="selectedRegionId"
          >
            <mat-option *ngFor="let region of regions" [value]="region.id">
              {{ 'regions.' + region.id | translate }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>

    <agr-summary-card
      [title]="'from-reference.list-title' | translate"
      [canExpand]="false"
      class="text--big"
    >
      <mat-list>
        <!-- Option to create feedadvice FROM SCRATCH -->
        <mat-list-item class="scheme-option-listitem">
          <span matListItemLine
            >{{ 'from-reference.from-scratch-title' | translate }}
            <span class="subtitle">{{ 'from-reference.from-scratch-subtitle' | translate }}</span>
          </span>

          <div matListItemMeta>
            <button
              type="button"
              mat-flat-button
              color="accent"
              (click)="createFeedAdviceFromScratch()"
              data-test="createFromScratch"
            >
              <mat-icon>arrow_forward</mat-icon>
              {{ 'from-reference.from-scratch-button' | translate }}
            </button>
          </div>
        </mat-list-item>

        <!-- Options to create feedadvice FROM REFERENCE SCHEME -->
        <h4>{{ 'from-reference.referenceschemes-list' | translate }}</h4>

        <mat-list-item
          class="scheme-option-listitem"
          *ngFor="let referenceFeedAdvice of filteredReferenceFeedAdvices$ | async"
        >
          <span data-test="referenceFeedAdvice-name" matListItemLine
            >{{ referenceFeedAdvice.name }} <br />
            <span class="subtitle" [innerHTML]="getReferenceSchemeInfo(referenceFeedAdvice)"></span>
          </span>

          <div matListItemMeta>
            <button
              type="button"
              mat-flat-button
              color="accent"
              (click)="createFeedAdviceFromReference(referenceFeedAdvice)"
              data-test="createFromReference"
            >
              <mat-icon>arrow_forward</mat-icon>
              {{ 'from-reference.from-reference-button' | translate }}
            </button>
          </div>
        </mat-list-item>
      </mat-list>
    </agr-summary-card>
  </div>
</agr-page-detail>
